/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCallinScriptTemplateDetail.ts    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/callin-script-template-detail";

export class AutogenModelCallinScriptTemplateDetail<RowType extends ModelRow> extends Endpoint<RowType, RowCallinScriptTemplateDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCallinScriptTemplateDetail extends ModelRow<RowCallinScriptTemplateDetailFields> {
	constructor(values?: Partial<RowCallinScriptTemplateDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCallinScriptTemplateDetailFields {
	callin_script_template_id: string;
	company_id: string;
	detail_type: string;
	display_stored_value: string;
	display_total_pay: string;
	field_info: string;
	field_name: string;
	id: string;
	include_input_field: string;
	is_required: string;
	prompt: string;
	save_data_field: string;
	sequence: number;
	stop_to_display: string;
	table_name: string;
	update_field: string;
	callin_field_lookup: string;
}

